var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cx from 'classnames';
import React from 'react';
var clamp = function (min, val, max) {
    if (val < min) {
        return min;
    }
    if (val > max) {
        return max;
    }
    return val;
};
var MIN_SIZE = 20;
var ResizeDirection = {
    top_right: '',
    bottom_right: '',
    bottom_left: '',
    top_left: '',
};
var ImageResizeBoxControl = /** @class */ (function (_super) {
    __extends(ImageResizeBoxControl, _super);
    function ImageResizeBoxControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.active = false;
        _this.height = 0;
        _this.width = 0;
        _this.frameID = 0;
        _this.x1 = 0;
        _this.x2 = 0;
        _this.y1 = 0;
        _this.y2 = 0;
        _this.resultWidth = 0;
        _this.resultHeight = 0;
        _this.syncSize = function () {
            if (!_this.active) {
                return;
            }
            var direction = _this.props.direction;
            var dx = (_this.x2 - _this.x1) * (/left/.test(direction) ? -1 : 1);
            var aspect = _this.width / _this.height;
            var ww = _this.width + Math.round(dx);
            if (_this.props.maxWidth) {
                ww = clamp(MIN_SIZE, _this.width + Math.round(dx), _this.props.maxWidth);
            }
            var hh = Math.max(ww / aspect, MIN_SIZE);
            ww = hh * aspect;
            _this.resultWidth = ww;
            _this.resultHeight = hh;
        };
        _this.onMouseDown = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.end();
            _this.start(e);
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.x2 = e.clientX;
            _this.y2 = e.clientY;
            _this.syncSize();
            _this.frameID = requestAnimationFrame(function () { return _this.props.onResizeEnd(_this.resultWidth, _this.resultHeight); });
        };
        _this.onMouseUp = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.x2 = e.clientX;
            _this.y2 = e.clientY;
            _this.end();
        };
        return _this;
    }
    ImageResizeBoxControl.prototype.componentWillUnmount = function () {
        this.end();
    };
    ImageResizeBoxControl.prototype.bindEvent = function () {
        document.addEventListener('mousemove', this.onMouseMove, true);
        document.addEventListener('mouseup', this.onMouseUp, true);
    };
    ImageResizeBoxControl.prototype.unBindEvent = function () {
        document.removeEventListener('mousemove', this.onMouseMove, true);
        document.removeEventListener('mouseup', this.onMouseUp, true);
    };
    ImageResizeBoxControl.prototype.render = function () {
        var _a;
        var _this = this;
        var direction = this.props.direction;
        var className = cx((_a = {
                'syl-image-resize-box-control': true
            },
            _a[direction] = true,
            _a));
        return React.createElement("span", { className: className, onMouseDown: function (e) { return _this.onMouseDown(e.nativeEvent); } });
    };
    ImageResizeBoxControl.prototype.start = function (e) {
        if (this.active) {
            this.end();
        }
        this.active = true;
        this.x1 = e.clientX;
        this.y1 = e.clientY;
        this.x2 = this.x1;
        this.y2 = this.y1;
        this.width = this.props.width;
        this.height = this.props.height;
        this.resultWidth = this.width;
        this.resultHeight = this.height;
        this.bindEvent();
        this.props.onResizeStart(this.resultWidth, this.resultHeight);
    };
    ImageResizeBoxControl.prototype.end = function () {
        if (!this.active) {
            return;
        }
        this.active = false;
        this.unBindEvent();
        this.frameID && cancelAnimationFrame(this.frameID);
        this.frameID = null;
    };
    return ImageResizeBoxControl;
}(React.PureComponent));
var ImageResizeBox = /** @class */ (function (_super) {
    __extends(ImageResizeBox, _super);
    function ImageResizeBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageResizeBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, onResizeEnd = _a.onResizeEnd, targetDOM = _a.targetDOM, onResizeStart = _a.onResizeStart;
        var _b = this.props, width = _b.width, height = _b.height;
        var imgDOM = null;
        if ((!width || !height) && (imgDOM = targetDOM.querySelector('img'))) {
            var rect = imgDOM.getBoundingClientRect();
            width = rect.width;
            height = rect.height;
        }
        var controls = Object.keys(ResizeDirection).map(function (key) { return (React.createElement(ImageResizeBoxControl, __assign({}, _this.props, { config: ResizeDirection[key], direction: key, height: height, key: key, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, width: width }))); });
        return (React.createElement("span", { className: "syl-resizable-container", style: { width: width, height: height } }, controls));
    };
    return ImageResizeBox;
}(React.PureComponent));
export { ImageResizeBox };
//# sourceMappingURL=image-resize-box.js.map